<div class="platform-icons">
    <img *ngFor="let icon of visibleIcons" class="platform-icon" [width]="iconSize" [height]="iconSize" [src]="icon.src | assetVersion" alt="">
    <img *ngIf="isVideo" class="platform-icon" [width]="iconSize" [height]="iconSize" [src]="'svg/video-icon.svg' | assetVersion" alt="Video">
</div>
